import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import BunkeyAPI from '../../../api/BunkeyAPI'
import NavBar from '../../nav-bar/PublicNavBar'
import BunkeyBotPublic from '../../bunkey-bot/BunkeyBotPublic'
import BigFooter from '../../footer/BigFooter'
import { Layout, Skeleton } from 'antd'
import MetaTags from 'react-meta-tags'
import moment from 'moment'
import './viewer.css'

const {
  Header, Content
} = Layout

export class Viewer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data: null,
      isFetching: true
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params
    const { token } = this.props
    BunkeyAPI({
      url: `/cms/posts/id/${id}`,
      method: 'POST',
      data: {
        token: token
      },
    }).then(resp => {
      this.setState({
        data: resp.data,
        isFetching: false
      })
    }).catch(err => {
      this.setState({
        data: null,
        isFetching: false
      })
    })
  }

  handleGetBackgroundColor(value) {
    if (!value) return
    let _class = ''
    switch (value.category) {
      case 'dam':
        _class = 'viewer-yellow'
        break;
      case 'marketing':
        _class = 'viewer-green'
        break;
      case 'bunkey':
        _class = 'viewer-purple'
        break;
      default:
        break;
    }
    return _class
  }

  render() {
    const { data, isFetching } = this.state

    return (
      <Layout>
        <MetaTags>
          <meta content="Bunkey" property="og:site_name" />
          {data && data.title && <React.Fragment>
            <meta content={data.title} name="description" property="og:description" />
            <meta content={data.title} property="og:title" />
            <meta content={data.viewImage} property="og:image" />

            <meta content={data.title} name="twitter:description" />
            <meta content={data.title} property="twitter:title" />
            <meta content={data.viewImage} name="twitter:image" />
          </React.Fragment>}
        </MetaTags>
        <Header className="pub-site-background-color-silver">
          <NavBar />
        </Header>
        <Content>
          <Skeleton loading={isFetching} active >
            <div className={this.handleGetBackgroundColor(data)}>
              <div className="viewer-title">{data && data.title}</div>
              <div className="viewer-subtitle">{data && data.category + ' | ' + moment(data.createdAt).locale('es').format("D MMMM YYYY")}</div>
            </div>
            <div className="viewer-image">
              {data && <img src={data.viewImage} alt='view' />}
            </div>
            <div className="viewer-content">
              {data && <div dangerouslySetInnerHTML={{ __html: data.content }}></div>}
            </div>
            <BunkeyBotPublic />
          </Skeleton>
        </Content>
        <BigFooter />
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.public.token
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Viewer)))
